// Mock data for Echo Media Software Company website

export const companyInfo = {
  name: "Echo Media",
  tagline: "Your Partner for MVPs, Products & Remote Teams",
  description: "We help startups and companies build MVPs, develop full-scale products, and scale faster with dedicated remote development teams.",
  mission: "Echo Media exists to help businesses grow by uniting software development, business consultancy, and digital media into one seamless service. We design and build smart digital products, provide data‑driven strategic guidance, and create impactful content that strengthens brands, optimises operations, and delivers measurable results.",
  vision: "To be the trusted digital partner that transforms businesses through intelligent software, strategic insight, and powerful digital media.",
  founded: "2018",
  address: "No 357, Industrial zone, Buttala",
  phone: "+94 74 200 7251",
  email: "Echomedia.mg@gmail.com",
  socialLinks: {
    linkedin: "https://linkedin.com/company/echomedia",
    twitter: "https://twitter.com/echomedia",
    github: "https://github.com/echomedia"
  }
};

export const services = [
  {
    id: 1,
    title: "Product Development",
    shortDescription: "End-to-end development of websites, mobile apps, and cloud systems built for scale.",
    fullDescription: "We build cutting-edge web applications using the latest technologies including React, Vue, and Angular. Our solutions are fast, secure, and scalable to meet your growing business needs.",
    icon: "Layers"
  },
  {
    id: 2,
    title: "MVP Development",
    shortDescription: "Launch your startup idea faster with lean, focused development approach.",
    fullDescription: "From concept to deployment, we create intuitive applications that provide seamless user experiences across all devices and platforms.",
    icon: "Rocket"
  },
  {
    id: 3,
    title: "SaaS Development",
    shortDescription: "Build secure, scalable SaaS platforms ready to launch and scale globally.",
    fullDescription: "We develop bespoke software solutions that streamline your operations, automate processes, and give you a competitive edge in your industry.",
    icon: "Cloud"
  },
  {
    id: 4,
    title: "AI/ML & Data Engineering",
    shortDescription: "Turn data into insights with machine learning and intelligent automation.",
    fullDescription: "Leverage the power of AI and machine learning with our expert services. We help you migrate, optimize, and manage your data infrastructure.",
    icon: "Brain"
  },
  {
    id: 5,
    title: "UI/UX Design",
    shortDescription: "Intuitive, engaging designs that turn users into loyal customers.",
    fullDescription: "Our design team creates stunning interfaces that are not only visually appealing but also provide exceptional user experiences that keep customers coming back.",
    icon: "Palette"
  },
  {
    id: 6,
    title: "Offshore Development",
    shortDescription: "High-performance remote development teams that integrate seamlessly.",
    fullDescription: "Our experienced teams work with you to develop technology strategies that align with your business goals and drive measurable results.",
    icon: "Users"
  }
];

export const serviceDropdown = [
  {
    title: "SOFTWARE SERVICES",
    items: services.map(s => s.title)
  },
  {
    title: "PHOTOGRAPHY",
    items: ["Wedding", "Event", "Birthday", "Fashion", "Product", "Commercial", "Property", "Any other event"]
  },
  {
    title: "VIDEOGRAPHY",
    items: ["Wedding", "Event", "Commercial", "Birthday", "Fashion", "Product", "Property", "Any Other Event"]
  },
  {
    title: "ADVERTISING",
    items: ["TV Commercial", "Brand Promotion", "Product Promotion"]
  },
  {
    title: "DIGITAL MARKETING SERVICES",
    items: [] // To be updated by user
  }
];


export const projects = [
  {
    id: 1,
    title: "Perks",
    description: "An innovative dual-sided marketplace platform connecting beauty and wellness clients with salon services, featuring an integrated Perk Coins loyalty reward system.",
    image: "https://images.pexels.com/photos/887751/pexels-photo-887751.jpeg?auto=compress&cs=tinysrgb&w=800",
    type: "Product Development",
    category: "Service Marketplace",
    status: "Live",
    technologies: ["Flutter", "Firebase", "Node.js"]
  },
  {
    id: 2,
    title: "Familink",
    description: "A comprehensive family-focused social media platform that enables users to create secure private groups, schedule family events, share memories, and maintain constant communication.",
    image: "https://images.pexels.com/photos/1092644/pexels-photo-1092644.jpeg?auto=compress&cs=tinysrgb&w=800",
    type: "Product Development",
    category: "Social Media",
    status: "Ongoing",
    technologies: ["Flutter", "Firebase", "Node.js"]
  },
  {
    id: 3,
    title: "Echo Mind",
    description: "A mental health and wellness application that enables users to track their emotional well-being, practice mindfulness exercises, and connect with mental health professionals.",
    image: "https://images.pexels.com/photos/39284/macbook-apple-imac-computer-39284.jpeg?auto=compress&cs=tinysrgb&w=800",
    type: "Product Development",
    category: "Healthcare",
    status: "Ongoing",
    technologies: ["React Native", "Firebase", "Node.js"]
  },
  {
    id: 4,
    title: "Kelsen",
    description: "A Complete, Customizable AI Platform for Law Firms. An integrated AI platform designed specifically for law firms, providing end-to-end solutions for Knowledge Management and legal research.",
    image: "https://images.pexels.com/photos/546819/pexels-photo-546819.jpeg?auto=compress&cs=tinysrgb&w=800",
    type: "Offshore Development",
    category: "LegalTech",
    status: "Ongoing",
    technologies: ["React", "NestJS", "AI/ML"]
  },
  {
    id: 5,
    title: "Web Operator",
    description: "A unified tool for managing web automation workflows, scraping structured data, and running interactive web testing. Built for teams that need to streamline repetitive web tasks.",
    image: "https://images.pexels.com/photos/1181244/pexels-photo-1181244.jpeg?auto=compress&cs=tinysrgb&w=800",
    type: "Offshore Development",
    category: "Developer Tools",
    status: "Ongoing",
    technologies: ["React", "NestJS", "Puppeteer"]
  },
  {
    id: 6,
    title: "5th Avenue",
    description: "Real estate platform for luxury property sales, rentals, and listings with an admin panel and client communication tools.",
    image: "https://images.pexels.com/photos/209726/pexels-photo-209726.jpeg?auto=compress&cs=tinysrgb&w=800",
    type: "Product Development",
    category: "Real Estate",
    status: "Ongoing",
    technologies: ["Next.js", "MongoDB", "WebSocket"]
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Kaweesha Dilshan",
    role: "CEO & Founder",
    bio: "As CEO & Founder, the leadership at Echo Media drives strategy, innovation, and culture. With a passion for using technology to simplify business, the focus is on building strong client relationships and delivering solutions that create real impact.",
    image: "/images/kaweesha-dilshan.jpg"
  },
  {
    id: 2,
    name: "Manju Siriwardana",
    role: "Managing Director",
    bio: "Bsc. Special in Business Management. Chairperson of Manju Engineering Pvt Ltd and Best Brand International Pvt Ltd. University Visiting Lecturer in Marketing, Motivational Speaker, Corporate Trainer, and Business Counselor.",
    image: "/images/manju-siriwardana.jpg"
  },
  {
    id: 3,
    name: "Dinusha Madushanka",
    role: "Director - Operations",
    bio: "With a strong foundation in Software Engineering, Dinusha brings a unique technical perspective to the role of Director of Operations. He leverages modern technology to streamline business processes, automate workflows, and drive maximum efficiency across the organization",
    image: "/images/dinusha-madushanka.jpg"
  }
];

export const stats = [
  { label: "Projects Delivered", value: "40+" },
  { label: "Happy Clients", value: "25+" },
  { label: "Countries Served", value: "9+" },
  { label: "Client Retention", value: "95%" }
];

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Services", path: "/services" },
  { name: "Projects", path: "/projects" },
  { name: "Contact", path: "/contact" }
];
